import { render, staticRenderFns } from "./Admin_Start.vue?vue&type=template&id=2eb1108f&scoped=true&"
import script from "./Admin_Start.vue?vue&type=script&lang=js&"
export * from "./Admin_Start.vue?vue&type=script&lang=js&"
import style0 from "./Admin_Start.vue?vue&type=style&index=0&id=2eb1108f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb1108f",
  null
  
)

export default component.exports